import firebase from 'firebase'
import { getToken } from '../helpers'

const state = {
  user: null,
  error: null
}

const mutations = {
  setUser (state, payload) {
    state.user = payload
  },
  setError (state, payload) {
    state.error = payload
  }
}

const actions = {
  userUpdate ({commit}, payload) {
    let tokenUser = getToken()
    let currentUser = firebase.auth().currentUser
    let promises = []
    if (tokenUser) {
      if (payload !== undefined) {
        if (payload.editUser && payload.key) {
          if (payload.editUser.email !== payload.currentUser.email) {
            let promiseUpdateEmail = currentUser.updateEmail(payload.editUser.email)
            promises.push(promiseUpdateEmail)
          }
          if (payload.editUser.password !== payload.currentUser.password) {
            let promiseUpdatePassword = currentUser.updatePassword(payload.editUser.password)
            promises.push(promiseUpdatePassword)
          }
          Promise.all(promises).then(() => {
            let updated = firebase.database().ref('users').child(payload.key).update(payload.editUser)
            if (updated) {
              window.location.reload()
            }
          })
        }
      }
    }
  },
  userRegister ({commit}, payload) {
    if (payload !== undefined) {
      if (payload.email && payload.password) {
        firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
          .then(response => {
            if (response.user) {
              let data = {
                uid: response.user.uid,
                displayName: payload.displayName,
                email: payload.email,
                photoURL: payload.photoURL,
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString()
              }
              firebase.database().ref('users').push().set(data)
              if (!localStorage.getItem('user')) {
                localStorage.setItem('user', JSON.stringify(response.user))
              }
              commit('setUser', data)
            }
          })
          .catch(err => commit('setError', err.message))
      }
    }
  },
  fetchUser ({commit}) {
    commit('setUser', null)
    let tokenUser = getToken()
    if (tokenUser) {
      firebase.database().ref('users').orderByChild('uid').equalTo(tokenUser).once('value')
        .then(snapshot => {
          let user = snapshot.val()
          user = Object.entries(user).map(([key, value]) => ({key, ...value}))
          commit('setUser', user[0])
        })
        .catch(err => commit('setError', err.message))
    }
  },
  userLogin ({commit}, payload) {
    firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
      .then(response => {
        if (!localStorage.getItem('user')) {
          localStorage.setItem('user', JSON.stringify(response.user))
        }
        commit('setUser', response.user)
        commit('setError', null)
      })
      .catch(err => commit('setError', err.message))
  },
  userLogout ({commit}, payload) {
    if (localStorage.getItem('user')) {
      localStorage.removeItem('user')
    }
    firebase.auth().signOut()
      .then(() => {
        commit('setUser', null)
        commit('setError', null)
      })
      .catch(err => commit('setError', err.message))
  },
  checkUserStatus ({commit}) {
    // if (localStorage.getItem('user')) {
    //   let localUser = JSON.parse(localStorage.getItem('user'))
    //   commit('setUser', localUser)
    // }
    commit('setUser', null)
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        commit('setUser', user)
      }
    })
  }
}

const getters = {
  user (state) {
    return state.user
  },
  error (state) {
    return state.error
  }
}

export default {
  namespaces: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/user.js